/**
 * Source Nodes - Magical Constants from the Enchanted Realm
 *
 * These values come from official Fairy Guild publications,
 * the Wizard's Almanac, and the Dragon Treasury Bureau.
 */

import { source, SourceNode } from '../../lib/computation-graph';

export const sources: Record<string, SourceNode> = {
  // Fairy Guild Regulations
  fairyLifespan: source('fairyLifespan', 150, {
    label: 'Fairy Lifespan',
    description: 'Average productive lifespan of a dust-producing fairy',
    unit: 'years',
    citation: {
      source: 'Fairy Guild Registry (Year of the Moon Moth)',
      description: 'Standard fairy lifecycle documentation',
      url: 'https://example.com/fairy-guild',
    },
  }),

  dustDepreciationRate: source('dustDepreciationRate', 2.5, {
    label: 'Dust Sparkle Decay Rate',
    description: 'Annual percentage sparkle loss in stored fairy dust',
    unit: 'percent',
    citation: {
      source: 'Enchanted Materials Institute',
      description: 'Fairy dust maintains 97.5% sparkle per year when properly stored',
    },
  }),

  // Wizard Tax Authority
  wizardGuildTaxRate: source('wizardGuildTaxRate', 15, {
    label: 'Wizard Guild Tax Rate',
    description: 'Standard tax on magical commodity sales',
    unit: 'percent',
    citation: {
      source: 'Wizard Tax Authority Codex',
      description: 'Section 7.3: Fairy Dust and Related Magical Exports',
    },
  }),

  elvishMinimumWage: source('elvishMinimumWage', 3, {
    label: 'Elvish Minimum Wage',
    description: 'Gold pieces per day for elf farm workers',
    unit: 'currency',
    citation: {
      source: 'Elvish Labor Council Decree',
      description: 'Fair Wages for Forest Folk Act',
    },
  }),

  // Dragon Treasury Standards
  dragonBondBaseRate: source('dragonBondBaseRate', 4.5, {
    label: 'Dragon Bond Base Rate',
    description: 'Risk-free rate from Dragon Treasury',
    unit: 'percent',
    citation: {
      source: 'Dragon Treasury Bureau',
      description: 'Backed by actual dragon hoards',
    },
  }),

  // Pixie Exchange Rates
  pixieDustConversion: source('pixieDustConversion', 0.3, {
    label: 'Pixie Dust Conversion',
    description: 'Ounces of pixie dust per ounce of fairy dust',
    unit: 'ratio',
    citation: {
      source: 'Interspecies Dust Exchange',
      description: 'Current market conversion rate',
    },
  }),

  // Unicorn Insurance Standards
  magicalLiabilityMinimum: source('magicalLiabilityMinimum', 500, {
    label: 'Magical Liability Insurance Minimum',
    description: 'Minimum required coverage in gold pieces',
    unit: 'currency',
    citation: {
      source: 'Unicorn Underwriters Association',
      description: 'Standard magical farm coverage requirements',
    },
  }),

  // Troll Bridge Authority
  trollTollRate: source('trollTollRate', 2, {
    label: 'Troll Bridge Toll Rate',
    description: 'Percentage toll on dust shipments crossing bridges',
    unit: 'percent',
    citation: {
      source: 'Troll Bridge Authority',
      description: 'Standard commercial toll rates',
    },
  }),
};

export default sources;
